'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_CreateGeneralPracticeRequest$UserData(fullName, phone) {
  this.Lapp_api_CreateGeneralPracticeRequest$UserData__f_fullName = null;
  this.Lapp_api_CreateGeneralPracticeRequest$UserData__f_phone = null;
  this.Lapp_api_CreateGeneralPracticeRequest$UserData__f_fullName = fullName;
  this.Lapp_api_CreateGeneralPracticeRequest$UserData__f_phone = phone;
}
export { $c_Lapp_api_CreateGeneralPracticeRequest$UserData as $c_Lapp_api_CreateGeneralPracticeRequest$UserData };
$c_Lapp_api_CreateGeneralPracticeRequest$UserData.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_CreateGeneralPracticeRequest$UserData.prototype.constructor = $c_Lapp_api_CreateGeneralPracticeRequest$UserData;
/** @constructor */
function $h_Lapp_api_CreateGeneralPracticeRequest$UserData() {
}
export { $h_Lapp_api_CreateGeneralPracticeRequest$UserData as $h_Lapp_api_CreateGeneralPracticeRequest$UserData };
$h_Lapp_api_CreateGeneralPracticeRequest$UserData.prototype = $c_Lapp_api_CreateGeneralPracticeRequest$UserData.prototype;
$c_Lapp_api_CreateGeneralPracticeRequest$UserData.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_api_CreateGeneralPracticeRequest$UserData.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-908826420), true);
});
$c_Lapp_api_CreateGeneralPracticeRequest$UserData.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lapp_api_CreateGeneralPracticeRequest$UserData) && ((this.Lapp_api_CreateGeneralPracticeRequest$UserData__f_fullName === x$0.Lapp_api_CreateGeneralPracticeRequest$UserData__f_fullName) && (this.Lapp_api_CreateGeneralPracticeRequest$UserData__f_phone === x$0.Lapp_api_CreateGeneralPracticeRequest$UserData__f_phone))));
});
$c_Lapp_api_CreateGeneralPracticeRequest$UserData.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_api_CreateGeneralPracticeRequest$UserData.prototype.productArity__I = (function() {
  return 2;
});
$c_Lapp_api_CreateGeneralPracticeRequest$UserData.prototype.productPrefix__T = (function() {
  return "UserData";
});
$c_Lapp_api_CreateGeneralPracticeRequest$UserData.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_api_CreateGeneralPracticeRequest$UserData__f_fullName;
  }
  if ((n === 1)) {
    return this.Lapp_api_CreateGeneralPracticeRequest$UserData__f_phone;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_api_CreateGeneralPracticeRequest$UserData.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "fullName";
  }
  if ((n === 1)) {
    return "phone";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_api_CreateGeneralPracticeRequest$UserData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_api_CreateGeneralPracticeRequest$UserData)));
}
export { $isArrayOf_Lapp_api_CreateGeneralPracticeRequest$UserData as $isArrayOf_Lapp_api_CreateGeneralPracticeRequest$UserData };
var $d_Lapp_api_CreateGeneralPracticeRequest$UserData = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_CreateGeneralPracticeRequest$UserData, "app.api.CreateGeneralPracticeRequest$UserData", ({
  Lapp_api_CreateGeneralPracticeRequest$UserData: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_api_CreateGeneralPracticeRequest$UserData as $d_Lapp_api_CreateGeneralPracticeRequest$UserData };
//# sourceMappingURL=app.api.-Create-General-Practice-Request$-User-Data.js.map
